/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../ui-elements/icon/icon.component.ngfactory';
import * as import2 from '../../ui-elements/icon/icon.component';
import * as import3 from '../../buttons/icon-button/icon-button.component.ngfactory';
import * as import4 from '../../buttons/icon-button/icon-button.component';
import * as import5 from '../../ui-elements/logo/logo.component.ngfactory';
import * as import6 from '../../ui-elements/logo/logo.component';
import * as import7 from '../../ordering-context/ordering-context.model';
import * as import8 from 'ng2-translate/src/translate.pipe';
import * as import9 from 'ng2-translate/src/translate.service';
import * as import10 from '../../orchestration/responsive.directive';
import * as import11 from '../../orchestration/responsive.service';
import * as import12 from '../../orchestration/navigation.service';
import * as import13 from '@angular/common';
import * as import14 from '../../notification/footer-messages/footer-messages.component.ngfactory';
import * as import15 from '../../notification/footer-messages/footer-messages.component';
import * as import16 from '../../notification/notification.service';
import * as import17 from './full-page-layout.component';
import * as import18 from '../../ui-elements/swipable.directive';
import * as import19 from '../../ui-elements/image/background-image.directive';
import * as import20 from '../../ui-elements/image/cached-image.service';
import * as import21 from '../../orchestration/page';
import * as import22 from '../../theme/theme.model';
const styles_FullPageLayoutComponent:any[] = ([] as any[]);
export const RenderType_FullPageLayoutComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_FullPageLayoutComponent,
  data: {}
}
);
function View_FullPageLayoutComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'swipe-refresh'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'swipe-refresh-indicator'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon',[
      [
        'class',
        'swipe-refresh-indicator-icon'
      ]
      ,
      [
        'name',
        'rotate-left'
      ]

    ]
    ,(null as any),(null as any),(null as any),import1.View_IconComponent_0,import1.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import2.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'rotate-left';
    ck(v,5,0,currVal_0);
  },(null as any));
}
function View_FullPageLayoutComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'navbar-buttons-button back'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.back()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_IconButtonComponent_0,import3.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import4.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.BACK;
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_FullPageLayoutComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-logo',[[
        'class',
        'navbar-title-logo logo'
      ]
    ],(null as any),(null as any),(null as any),import5.View_LogoComponent_0,import5.RenderType_LogoComponent)),
      import0.ɵdid(49152,(null as any),0,import6.LogoComponent,[import7.OrderingContextModel],{type: [
        0,
        'type'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'horizontal';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_FullPageLayoutComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'navbar-title-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import9.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.navbarTitle,co.translationParams));
    ck(v,1,0,currVal_0);
  });
}
function View_FullPageLayoutComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'navbar-buttons-button refresh'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.onRefresh.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_IconButtonComponent_0,import3.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import4.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.REFRESH;
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_FullPageLayoutComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'navbar-buttons-button exit'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.onExit.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_IconButtonComponent_0,import3.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import4.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.EXIT;
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_FullPageLayoutComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),31,'div',[
      [
        'class',
        'navbar'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(737280,(null as any),0,import10.ResponsiveDirective,[
      import0.ElementRef,
      import11.ResponsiveService,
      import12.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'navbar-buttons left'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_FullPageLayoutComponent_3)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import13.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n            '])),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'navbar-title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FullPageLayoutComponent_4)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FullPageLayoutComponent_5)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'navbar-buttons right'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    import0.ɵncd((null as any),1),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FullPageLayoutComponent_6)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FullPageLayoutComponent_7)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    ck(v,1,0);
    const currVal_0:any = ((co.navigationService.canDismissView() && !co.hideBackButton) && (import0.ɵunv(v,6,0,import0.ɵnov(v,7).transform(co.responsiveService.mobile$)) || co.showBackButtonOnDesktop));
    ck(v,6,0,currVal_0);
    const currVal_1:any = co.showNavbarLogo;
    ck(v,15,0,currVal_1);
    const currVal_2:any = co.navbarTitle;
    ck(v,18,0,currVal_2);
    const currVal_3:any = co.showRefreshButton;
    ck(v,26,0,currVal_3);
    const currVal_4:any = co.showExitButton;
    ck(v,29,0,currVal_4);
  },(null as any));
}
function View_FullPageLayoutComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'navbar-buttons-button back floating'
      ]
    ],[
      [
        2,
        'circular',
        (null as any)
      ]
      ,
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.back()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_IconButtonComponent_0,import3.RenderType_IconButtonComponent)),
    import0.ɵdid(49152,(null as any),0,import4.IconButtonComponent,([] as any[]),{
      type: [
        0,
        'type'
      ]
      ,
      circular: [
        1,
        'circular'
      ]

    }
    ,{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_4:any = co.IconButtonType.BACK;
    const currVal_5:any = co.makeFloatingBackButtonCircular;
    ck(v,1,0,currVal_4,currVal_5);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.makeFloatingBackButtonCircular;
    const currVal_1:any = import0.ɵnov(v,1).type;
    const currVal_2:any = import0.ɵnov(v,1).disabled;
    const currVal_3:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3);
  });
}
function View_FullPageLayoutComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'page-content-body-titles-title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import9.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.title,co.translationParams));
    ck(v,1,0,currVal_0);
  });
}
function View_FullPageLayoutComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'page-content-body-titles-subtitle'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import9.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.subtitle,co.translationParams));
    ck(v,1,0,currVal_0);
  });
}
function View_FullPageLayoutComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'page-content-body-titles'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FullPageLayoutComponent_11)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FullPageLayoutComponent_12)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.title;
    ck(v,3,0,currVal_0);
    const currVal_1:any = (co.showSubtitle && co.subtitle);
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_FullPageLayoutComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,[
      [
        1,
        0
      ]
      ,
      [
        'content',
        1
      ]

    ]
    ,(null as any),34,'div',[
      [
        'class',
        'page-content-body'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import13.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['locked']),
    import0.ɵdid(737280,(null as any),0,import10.ResponsiveDirective,[
      import0.ElementRef,
      import11.ResponsiveService,
      import12.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FullPageLayoutComponent_10)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'page-content-body-messages'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    import0.ɵncd((null as any),2),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),20,'div',[[
        'class',
        'page-content-body-main'
      ]
      ],[[
        8,
        'hidden',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import13.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import13.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod(['double-pillarboxed']),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'page-content-body-main-section'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import13.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import13.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod(['left']),
    import0.ɵncd((null as any),3),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'page-content-body-main-section'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵncd((null as any),4),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'page-content-body-main-section'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import13.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import13.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod(['right']),
    import0.ɵncd((null as any),5),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'page-content-body';
    const currVal_1:any = ck(v,2,0,co.contentLocked);
    ck(v,1,0,currVal_0,currVal_1);
    ck(v,3,0);
    const currVal_2:any = (co.showTitles && (co.title || co.subtitle));
    ck(v,6,0,currVal_2);
    const currVal_4:any = 'page-content-body-main';
    const currVal_5:any = ck(v,16,0,(import0.ɵunv(v,14,1,import0.ɵnov(v,15).transform(co.responsiveService.desktop$)) && (co.pillarboxedOnDesktop === 'double-mobile')));
    ck(v,14,0,currVal_4,currVal_5);
    const currVal_6:any = 'page-content-body-main-section';
    const currVal_7:any = ck(v,22,0,(import0.ɵunv(v,20,1,import0.ɵnov(v,21).transform(co.responsiveService.desktop$)) && (co.pillarboxedOnDesktop === 'double-mobile')));
    ck(v,20,0,currVal_6,currVal_7);
    const currVal_8:any = 'page-content-body-main-section';
    const currVal_9:any = ck(v,31,0,(import0.ɵunv(v,29,1,import0.ɵnov(v,30).transform(co.responsiveService.desktop$)) && (co.pillarboxedOnDesktop === 'double-mobile')));
    ck(v,29,0,currVal_8,currVal_9);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_3:boolean = !co.showContent;
    ck(v,13,0,currVal_3);
  });
}
function View_FullPageLayoutComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'page-footer'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import13.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-footer-shadow']),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-footer-messages',([] as any[]),(null as any),(null as any),(null as any),import14.View_FooterMessagesComponent_0,import14.RenderType_FooterMessagesComponent)),
    import0.ɵdid(49152,(null as any),0,import15.FooterMessagesComponent,[
      import16.NotificationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    import0.ɵncd(1,6),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'page-footer-main'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    import0.ɵncd((null as any),7),
    (l()(),import0.ɵted((null as any),['\n                '])),
    import0.ɵncd((null as any),8),
    (l()(),import0.ɵted((null as any),['\n                '])),
    import0.ɵncd((null as any),9),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'page-footer';
    const currVal_1:any = ck(v,2,0,(co.showFooterShadow || ((co.showFooterShadow === (undefined as any)) && co.footerControls.length)));
    ck(v,1,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_FullPageLayoutComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(671088640,1,{contentElementRef: 0}),
    import0.ɵqud(402653184,2,{scrollerElementRef: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),41,'div',[
      [
        'class',
        'full-page'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]
      ,
      [
        'woa-swipable',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'onSwipe'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import17.FullPageLayoutComponent = v.component;
      if (('onSwipe' === en)) {
        const pd_0:any = ((<any>co.onRefresh.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import13.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['allowSafeArea']),
    import0.ɵdid(737280,(null as any),0,import10.ResponsiveDirective,[
      import0.ElementRef,
      import11.ResponsiveService,
      import12.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,{
      pillarboxedOnMobile: [
        0,
        'pillarboxedOnMobile'
      ]
      ,
      pillarboxedOnDesktop: [
        1,
        'pillarboxedOnDesktop'
      ]

    }
    ,(null as any)),
    import0.ɵdid(212992,(null as any),0,import18.SwipableDirective,[
      import0.ElementRef,
      import0.Renderer2
    ]
    ,{
      swipeEnabled: [
        0,
        'swipeEnabled'
      ]
      ,
      swipeScale: [
        1,
        'swipeScale'
      ]
      ,
      swipeEase: [
        2,
        'swipeEase'
      ]
      ,
      swipeRangeDistance: [
        3,
        'swipeRangeDistance'
      ]
      ,
      swipePrimeProportionOfRange: [
        4,
        'swipePrimeProportionOfRange'
      ]
      ,
      swipeScroller: [
        5,
        'swipeScroller'
      ]

    }
    ,{onSwipe: 'onSwipe'}),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FullPageLayoutComponent_1)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FullPageLayoutComponent_2)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_FullPageLayoutComponent_8)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import13.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),24,'div',[[
        'class',
        'background'
      ]
      ],(null as any),[[
        (null as any),
        'backgroundImageApplied'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import17.FullPageLayoutComponent = v.component;
      if (('backgroundImageApplied' === en)) {
        const pd_0:any = ((<any>co.backgroundImageApplied.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import13.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['transparent']),
    import0.ɵdid(16384,(null as any),0,import19.BackgroundImageDirective,[
      import0.ElementRef,
      import0.Renderer2,
      import20.CachedImageService
    ]
      ,{imageSpecs: [
        0,
        'imageSpecs'
      ]
    },{backgroundImageApplied: 'backgroundImageApplied'}),
    import0.ɵpid(131072,import13.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import13.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod([
      'conditional',
      'on',
      'image',
      'opacity',
      'classes'
    ]
    ),
    import0.ɵpod([
      'classes',
      'conditional'
    ]
    ),
    import0.ɵpad(2),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'page-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import13.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import13.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod([
      'with-divider',
      'with-title'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,[
      [
        2,
        0
      ]
      ,
      [
        'scroller',
        1
      ]

    ]
      ,(null as any),4,'div',[[
        'class',
        'scroller'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FullPageLayoutComponent_9)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FullPageLayoutComponent_13)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import17.FullPageLayoutComponent = v.component;
    const currVal_0:any = 'full-page';
    const currVal_1:any = ck(v,4,0,co.allowSafeArea);
    ck(v,3,0,currVal_0,currVal_1);
    const currVal_2:any = co.pillarboxedOnMobile;
    const currVal_3:any = co.pillarboxedOnDesktop;
    ck(v,5,0,currVal_2,currVal_3);
    const currVal_4:any = (co.enableSwipeRefresh && co.responsiveService.mobile);
    const currVal_5:any = 0.3;
    const currVal_6:any = true;
    const currVal_7:any = 150;
    const currVal_8:any = 0.85;
    const currVal_9:any = co.scrollerElementRef;
    ck(v,6,0,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
    const currVal_10:any = (co.enableSwipeRefresh && co.responsiveService.mobile);
    ck(v,9,0,currVal_10);
    const currVal_11:any = co.showNavbar;
    ck(v,12,0,currVal_11);
    const currVal_12:boolean = (((!co.showNavbar && co.navigationService.canDismissView()) && !co.hideBackButton) && (import0.ɵunv(v,15,0,import0.ɵnov(v,16).transform(co.responsiveService.mobile$)) || co.showBackButtonOnDesktop));
    ck(v,15,0,currVal_12);
    const currVal_13:any = 'background';
    const currVal_14:any = ck(v,20,0,co.transparent);
    ck(v,19,0,currVal_13,currVal_14);
    var tmp_15_0:any = (null as any);
    const currVal_15:any = ck(v,26,0,ck(v,24,0,true,co.showLoginBackgroundImage,(((tmp_15_0 = co.appData(import0.ɵunv(v,21,0,import0.ɵnov(v,22).transform(co.SessionEvents.currentApp$)))) == null)? (null as any): tmp_15_0.loginImage),(((tmp_15_0 = co.appData(import0.ɵunv(v,21,0,import0.ɵnov(v,23).transform(co.SessionEvents.currentApp$)))) == null)? (null as any): tmp_15_0.loginImageOpacity),'theme-standard-page-image-color-pair'),ck(v,25,0,(('theme-' + co.backgroundColorPair) + '-color-pair'),false));
    ck(v,21,0,currVal_15);
    const currVal_16:any = 'page-content';
    const currVal_17:any = ck(v,31,0,(import0.ɵunv(v,29,1,import0.ɵnov(v,30).transform(co.responsiveService.desktop$)) && (co.pillarboxedOnDesktop === 'double-mobile')),(co.navbarTitle || co.showNavbarLogo));
    ck(v,29,0,currVal_16,currVal_17);
    const currVal_18:any = co.showContent;
    ck(v,36,0,currVal_18);
    const currVal_19:any = co.showFooter;
    ck(v,41,0,currVal_19);
  },(null as any));
}
function View_FullPageLayoutComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-full-page-layout',([] as any[]),(null as any),(null as any),(null as any),View_FullPageLayoutComponent_0,RenderType_FullPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),1,import17.FullPageLayoutComponent,[
      import21.Page,
      import12.NavigationService,
      import11.ResponsiveService,
      import22.ThemeModel
    ]
    ,(null as any),(null as any)),
    import0.ɵqud(603979776,1,{footerControls: 1}),
    import0.ɵprd(6144,(null as any),import21.PageLayout,(null as any),[import17.FullPageLayoutComponent])
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const FullPageLayoutComponentNgFactory:import0.ComponentFactory<import17.FullPageLayoutComponent> = import0.ɵccf('woa-full-page-layout',import17.FullPageLayoutComponent,View_FullPageLayoutComponent_Host_0,{
  showNavbar: 'showNavbar',
  showNavbarLogo: 'showNavbarLogo',
  autoDismissOnBack: 'autoDismissOnBack',
  hideBackButton: 'hideBackButton',
  makeFloatingBackButtonCircular: 'makeFloatingBackButtonCircular',
  showBackButtonOnDesktop: 'showBackButtonOnDesktop',
  showRefreshButton: 'showRefreshButton',
  enableSwipeRefresh: 'enableSwipeRefresh',
  showExitButton: 'showExitButton',
  showTitles: 'showTitles',
  showSubtitle: 'showSubtitle',
  navbarTitle: 'navbarTitle',
  title: 'title',
  subtitle: 'subtitle',
  translationParams: 'translationParams',
  transparent: 'transparent',
  showLoginBackgroundImage: 'showLoginBackgroundImage',
  backgroundColorPair: 'backgroundColorPair',
  pillarboxedOnMobile: 'pillarboxedOnMobile',
  pillarboxedOnDesktop: 'pillarboxedOnDesktop',
  showContent: 'showContent',
  contentLocked: 'contentLocked',
  showFooter: 'showFooter',
  showFooterShadow: 'showFooterShadow',
  allowSafeArea: 'allowSafeArea'
}
,{
  backgroundImageApplied: 'backgroundImageApplied',
  onBack: 'onBack',
  onRefresh: 'onRefresh',
  onExit: 'onExit'
}
,[
  '[slot=navbar-left]',
  '[slot=navbar-right]',
  'woa-content-message',
  '[slot=content-left]',
  '*',
  '[slot=content-right]',
  'woa-footer-message, [slot=footer-messages]',
  '[slot=footer-start]',
  '[woa-page-footer-control]',
  '[slot=footer-end]'
]
);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/page-layout/full-page-layout/full-page-layout.component.ngfactory.ts